var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-qr',{staticStyle:{"width":"120px","height":"120px"},attrs:{"logo-src":_vm.logoSrc,"text":_vm.url,"margin":10,"size":600,"logo-scale":0.15}})
}
var staticRenderFns = []

export { render, staticRenderFns }